import React, { useState } from "react";
import { Box, CircularProgress, Grid, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { H2 } from "../../components/typography";
import ComponentsContainer from "../../components/ComponentsContainer";
import { TextField } from "../../components/textfield";
import { Button } from "../../components/button";
import { COLORS } from "../../theme";

const placeholder = {
  friendName: "Din kompis namn",
  friendPhone: "Din kompis telefonnummer",
  myName: "Ditt namn",
};

const ChallengeFriend = () => {
  const [friendName, setFriendName] = useState("");
  const [myName, setMyName] = useState("");
  const [friendPhone, setFriendPhone] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const fields = [
    {
      name: placeholder.friendName,
      value: friendName,
      onChange: setFriendName,
      placeholder: placeholder.friendName,
    },
    {
      name: placeholder.friendPhone,
      value: friendPhone,
      onChange: setFriendPhone,
      placeholder: placeholder.friendPhone,
    },
    {
      name: placeholder.myName,
      value: myName,
      onChange: setMyName,
      placeholder: placeholder.myName,
    },
  ];

  const onClick = async () => {
    setIsLoading(true);
    try {
      await fetch("https://sms-gateway-kf4vxl73ya-lz.a.run.app/sms", {
        method: "POST",
        body: JSON.stringify({
          secret: "fQDJnyU0oy5nlMlfjXzo",
          mobile: friendPhone
            .replace("+", "")
            .replace(" ", "")
            .replace("-", "")
            .replace(/^07/, "467"),
        }),
      });
    } catch (_) {
      // eslint-disable-next-line no-alert
    } finally {
      setShowSuccess(true);
      setIsLoading(false);
    }
  };

  const handleOnBackClick = () => {
    window.location.href = "https://spelarguiden.com/module3/quiz";
  };

  const isMobile = useMediaQuery(useTheme().breakpoints.down("md"), {
    noSsr: true,
  });

  return (
    <ComponentsContainer
      sx={{
        backgroundColor: COLORS.darkBlue,
        height: "100vh",
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          marginLeft: isMobile ? 3 : 0,
          marginRight: isMobile ? 3 : 0,
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          justifyContent: showSuccess ? "space-around" : "center",
          height: "inherit",
        }}
      >
        <H2 color={COLORS.white}>
          {showSuccess ? "UTMANINGEN ÄR SKICKAD" : "UTMANA EN KOMPIS!"}
        </H2>

        {!showSuccess &&
          fields.map((field) => {
            return (
              <Grid
                key={field.name}
                container
                sx={{
                  width: "100%",
                }}
                columnSpacing={isMobile ? 0 : 5}
              >
                <Grid item xs={12} lg={12} xl={12}>
                  <TextField
                    sx={{
                      marginTop: 5,
                      "&.MuiInput-underline:before": {
                        borderBottomColor: "orange",
                      },
                      "&.MuiInput-underline:after": {
                        borderBottomColor: "orange",
                      },
                    }}
                    fullWidth
                    variant="filled"
                    label={field.name}
                    value={field.value}
                    placeholder={field.placeholder}
                    onChange={(e) => field.onChange(e.target.value)}
                  />
                </Grid>
              </Grid>
            );
          })}

        {showSuccess ? (
          <Button
            textColor={COLORS.white}
            fullWidth
            sx={{
              mt: 4,
              mb: 6,
              borderRadius: 100,
            }}
            onClick={handleOnBackClick}
          >
            Tillbaka
          </Button>
        ) : (
          <Button
            textColor={COLORS.white}
            fullWidth
            sx={{
              mt: 4,
              mb: 6,
              borderRadius: 100,
            }}
            onClick={onClick}
            disabled={isLoading}
          >
            {isLoading ? <CircularProgress /> : "Skicka"}
          </Button>
        )}
      </Box>
    </ComponentsContainer>
  );
};

export default ChallengeFriend;
